import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { MapTrackerComponent } from "./map-tracker/map-tracker.component";
import { ProfileComponent } from "./profile/profile.component";
import { TripsComponent } from "./trips/trips.component";
import { TruckDetailsComponent } from "./truck-details/truck-details.component";

const routes: Routes = [
  {
    path: "truck-details",
    component: TruckDetailsComponent,
  },
  {
    path: "profile",
    component: ProfileComponent,
  },
  {
    path: "dashboard",
    component: DashboardComponent,
  },
  {
    path: "trips",
    component: TripsComponent,
  },
  {
    path: "map-tracker",
    component: MapTrackerComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerRoutingModule {}
